import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './features/loader/Loader';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/login/Login';
import Portal from './pages/portal/Portal';
import './css/gspoi.css';
import { getAuthToken, getAuthUser } from './services/storage';
import PasswordResetPage from './pages/passwordReset/PasswordResetPage';
import PasswordResetRequestPage from './pages/passwordResetRequest/PasswordResetRequestPage';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Feedback from "./pages/feedback/Feedback";


// import NotFound from './pages/notFound/NotFound';


function App() {

  const dispatch = useDispatch();
  const location = useLocation();


  useEffect(() => {
    // redirect to login if not logged in
    if (!window.location.pathname.includes('/login')) {
      let AuthToken = getAuthToken();
      let AuthUser = getAuthUser();
  
      if (!AuthToken || !AuthUser) {
        window.location.href = '/login';
      }
    }
  }, []);

  const getLocationClassName = (location) => {
    return location.pathname.replace(/\//g, ' ');
  };

  return (
    <>
      <Routes>  
        <Route path="/login/password-reset/:token" element={<PasswordResetPage />} key="password-reset"/>
        <Route path="/login/forgotten-password" element={<PasswordResetRequestPage />} key="forgotten-password"/>
        <Route path="/login" element={<LoginPage />} key="login"/>
        <Route path="/portal/*" element={<Portal />} key="portal-student" />            
      </Routes>
    </>
  );
}

export default App;
